import { typographyTokens } from '../../theme/typographyTokens';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { TaskStatus } from '../../../shared/types/Task';
import { newUiColorTokens } from '../../theme/themeTokens';

const CellItem = ({
  icon,
  text,
  color,
}: {
  icon?: React.ReactNode;
  text: string;
  color: string;
}) => (
  <Box
    display="flex"
    alignItems="center"
    px="16px"
    py="4px"
    sx={{
      backgroundColor: color,
      maxWidth: 'max-content',
      minWidth: '100px',
    }}
  >
    {icon}
    <Typography fontSize={typographyTokens.fontSizes.base} fontWeight={typographyTokens.fontWeights.regular} color={'#222222'} ml={icon ? "8px" : "0"}>
      {text}
    </Typography>
  </Box>
);

const StatusCell = ({ status, showIcon = true }: { status: TaskStatus; showIcon?: boolean }) => {
  if (status === TaskStatus.inReview) {
    return (
      <CellItem
        icon={
          showIcon ? (
            <i
              className="fa-regular fa-hand-wave"
              style={{ color: newUiColorTokens.prime.orange }}
            ></i>
          ) : undefined
        }
        color="#FFFBF6"
        text="Needs Review"
      />
    );
  }
  if (status === TaskStatus.changesRequested) {
    return (
      <CellItem
        icon={
          showIcon ? (
            <i
              className="fa-regular fa-hand-wave"
              style={{ color: newUiColorTokens.prime.orange }}
            ></i>
          ) : undefined
        }
        color="#FFFBF6"
        text="Changes Requested"
      />
    );
  }
  if (status === TaskStatus.complete) {
    return (
      <CellItem
        icon={
          showIcon ? (
            <i className="fa-solid fa-check" style={{ color: newUiColorTokens.prime.green }}></i>
          ) : undefined
        }
        color="#F3F8F0"
        text="Complete"
      />
    );
  }
  if (status === TaskStatus.todo) {
    return (
      <CellItem
        icon={
          showIcon ? (
            <i
              className="fa-solid fa-note-sticky"
              style={{ color: newUiColorTokens.prime.blue }}
            ></i>
          ) : undefined
        }
        color="#EDF4FA"
        text="To-Do"
      />
    );
  }
  if (status === TaskStatus.pending) {
    return (
      <CellItem
        icon={
          showIcon ? (
            <i
              className="fa-regular fa-ellipsis"
              style={{ color: newUiColorTokens.prime.granite }}
            ></i>
          ) : undefined
        }
        color="#F2F2F2"
        text="Locked"
      />
    );
  }
  return <Box>{status}</Box>;
};

export default StatusCell;
